var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offer-attributes" },
    [
      _c("div", { staticClass: "row" }, [
        _c("h2", {
          staticClass: "mt-3",
          domProps: { textContent: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6" },
          _vm._l(_vm.leftDetails, function (detail) {
            return _c("div", { key: detail.icon }, [
              _c("div", { staticClass: "d-flex" }, [
                _c("p", { staticClass: "pe-1" }, [
                  _c("span", {
                    staticClass: "icon h1",
                    class: detail.icon,
                    attrs: { "aria-hidden": "true" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pt-1" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: detail.descriptionBbcode,
                        expression: "detail.descriptionBbcode",
                      },
                    ],
                    staticClass: "px-1 pb-1",
                  }),
                ]),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6" },
          _vm._l(_vm.rightDetails, function (detail) {
            return _c("div", { key: detail.icon }, [
              _c("div", { staticClass: "d-flex" }, [
                _c("p", { staticClass: "pe-1" }, [
                  _c("span", {
                    staticClass: "icon h1",
                    class: detail.icon,
                    attrs: { "aria-hidden": "true" },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pt-1" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "safe-html",
                        rawName: "v-safe-html",
                        value: detail.descriptionBbcode,
                        expression: "detail.descriptionBbcode",
                      },
                    ],
                    staticClass: "px-1 pb-1",
                  }),
                ]),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.tvDetails
        ? [
            _c("InternetTvDetails", {
              attrs: {
                title: _vm.tvDetails.title,
                details: _vm.tvDetails.details,
                "responsive-illustration": _vm.tvDetails.illustration,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.editoPopins, function (editoPopin) {
        return _c("EditoPopin", {
          key: editoPopin.id,
          attrs: {
            "popin-id": editoPopin.popinModal.id,
            title: editoPopin.title,
            visual: editoPopin.visual,
            sections: editoPopin.sections,
            mentions: editoPopin.mentions,
          },
        })
      }),
      _vm._v(" "),
      _vm.mobileOptionPopin
        ? _c("OptionEditoPopin", {
            attrs: {
              "popin-id": _vm.mobileOptionPopin.popinModal.id,
              title: _vm.mobileOptionPopin.title,
              visual: _vm.mobileOptionPopin.visual,
              sections: _vm.mobileOptionPopin.sections,
              mentions: _vm.mobileOptionPopin.mentions,
              price: _vm.mobileOptionPopin.priceInCents,
              "alert-message": _vm.mobileOptionPopin.alertMessage,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.destinationPopin
        ? _c("ThreeColumnsEditoPopin", {
            attrs: {
              "popin-id": _vm.destinationPopin.popinModal.id,
              title: _vm.destinationPopin.title,
              visual: _vm.destinationPopin.visual,
              sections: _vm.destinationPopin.sections,
              mentions: _vm.destinationPopin.mentions,
              "first-column-sections": _vm.destinationPopin.firstColumnSections,
              "second-column-sections":
                _vm.destinationPopin.secondColumnSections,
              "third-column-sections": _vm.destinationPopin.thirdColumnSections,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }